export enum BankingApplicationStatus {
  Pending = 'pending',
  PendingReview = 'pending_review',
  Approved = 'approved',
  AwaitingDocuments = 'awaiting_documents',
  Denied = 'denied',
  Canceled = 'canceled',
}

// Mirrors the server's BankingAnalyticsStage funnel values
// (apps/api/src/api/component/banking/analytics/banking-analytics.constants.ts).
export enum BankingAnalyticsStage {
  ApplicationInProgress = 'application_in_progress',
  PendingReview = 'pending_review',
  Approved = 'approved',
  Denied = 'denied',
  Canceled = 'canceled',
  PlaidConnected = 'plaid_connected',
  AccountUse = 'account_use',
}

export type BankingProfile = {
  id: number
  applicationStatus: BankingApplicationStatus
  analyticsStage: BankingAnalyticsStage | null
  providerUserId: string | null
  updatedAt: string
}

export type EnsureBankingProfileResponse = {
  bankingProfile: BankingProfile
}

export type GetBankingProfileResponse = {
  bankingProfile: BankingProfile | null
}

export type AdminBankingProfile = {
  id: number
  userId: number
  provider: string
  providerUserId: string | null
  applicationStatus: BankingApplicationStatus
  createdAt: string
  updatedAt: string
  unitConsoleUrl: string | null
}

export type GetAdminBankingProfileResponse = {
  bankingProfile: AdminBankingProfile | null
}
